import { Component, input } from '@angular/core';
import { I18nModule } from '@spartacus/core';
import { PaymentsMods } from '../../config/app.config';
import { OrderPaymentInfo } from '../../models/order.model';
import { InvoiceUtils } from '../../utils/invoice.utils';

@Component({
  selector: 'sanofi-payment-information',
  standalone: true,
  imports: [
    I18nModule
  ],
  templateUrl: './payment-information.component.html',
})
export class PaymentInformationComponent {
  paymentType = input.required<PaymentsMods>();
  paymentInfo = input.required<OrderPaymentInfo>();

  protected readonly PaymentsMods = PaymentsMods;
  protected readonly InvoiceUtils = InvoiceUtils;
}
